import { ValidatorFn, Validators } from '@angular/forms';

export function phoneValidator(): ValidatorFn {
  return Validators.pattern(/(\b(0041|0)|\B\+41)(\s?\(0\))?(\s)?[1-9]{2}(\s)?[0-9]{3}(\s)?[0-9]{2}(\s)?[0-9]{2}\b/);
}
